import React from 'react';
import PropTypes from 'prop-types';
import {StyledIconWrapper} from './StyledIconWrapper';

const IconWrapper = ({
  children,
  color,
  colorMode = 'fill', // also color mode can be array ['fill', 'stroke'] for multi-color icons
  size = 24,
  rotate = 0,
  ...rest
}) => {

  return (
    <StyledIconWrapper color={color} size={size} colorMode={colorMode} rotate={rotate} {...rest}>
      {children}
    </StyledIconWrapper>
  );
}

IconWrapper.propTypes = {
  color: PropTypes.string,
  colorMode: PropTypes.oneOf(['fill', 'stroke']),
}

export default IconWrapper;
